// extracted by mini-css-extract-plugin
export var legendIndicator = "_cq-1";
export var legendRight = "_cq-0";